import { Component } from '@angular/core';
import { AuthenticationService } from './../services/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { LoadingController, ToastController, Platform } from '@ionic/angular';
import { AngularDelegate, ModalController, NavParams } from '@ionic/angular';
import { DocumentViewer, DocumentViewerOptions } from '@ionic-native/document-viewer/ngx';
import { File } from '@ionic-native/file/ngx';
import { FileTransfer, FileUploadOptions} from '@ionic-native/file-transfer/ngx';

@Component({
  selector: 'app-viewtask',
  templateUrl: 'viewtask.page.html',
  styleUrls: ['viewtask.page.scss']
})
  
export class ViewtaskPage {

  task: any=[];
  materials: any=[];
  state: any=[];
  img_link: string;

  task_api_data: any=[];
  constructor(private platform: Platform, private authService: AuthenticationService, private loadingController: LoadingController, private modalController: ModalController, private toastController: ToastController, navParams: NavParams, private document: DocumentViewer, private file: File, private fileTransfer: FileTransfer) { 

    let task = navParams.get('task');
    this.task.ready = false;

    this.loadTask(task.team_id, task.id).then(() => {
      this.loadTaskMaterials().then(() => {
        this.loadTaskFeedback();
      });
    });
  
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  loadMaterial(material) {


    if (material.file_type == 'pdf') {
    let downloadUrl = encodeURI(this.authService.getServerUri()+material.api_endpoint);

    let access_token = this.authService.getToken();
    let options = {
      headers: {
        'Authorization': 'Bearer '+access_token
      }
    }

    let path = null;
    
    if (this.platform.is('ios')) {
      path = this.file.documentsDirectory;
    } else if (this.platform.is('android')) {
      path = this.file.dataDirectory;
    }
    const transfer = this.fileTransfer.create();

    transfer.download(downloadUrl, path+material.name, false, options).then(entry => {
      


      let url = entry.toURL();

      const options: DocumentViewerOptions = {
        title: material.name,
        print : {
          enabled : true,
        },
        documentView : {
          closeLabel : 'Fertig'
        },
        navigationView : {
          closeLabel : 'Fertig'
        },
        openWith : {
          enabled : true,
        },
        bookmarks : {
          enabled : true,
        },
        search : {
          enabled : true,
        },

      }

      this.document.viewDocument(url, 'application/pdf', options);
    })
    } else {
      this.notifyUser('Öffnen von '+material.file_type+' Dateien nicht möglich.');

    }
  }

  async loadTask(team_id, task_id) {

    const loading =  await this.loadingController.create({
      message: "Laden Aufgabe...",
    });

    await loading.present();
    
    this.authService.getFromEndpoint('teams/'+team_id+'/tasks/'+task_id).subscribe(data => {
      this.task = data;
      this.task.ready = true;
      loading.dismiss();
    })
  }

  async loadTaskMaterials() {

    const loading =  await this.loadingController.create({
      message: "Lade Materialien...",
    });

    await loading.present();

   this.authService.getFromEndpoint('teams/'+this.task.team_id+'/tasks/'+this.task.id+'/materials').subscribe(materials => {
    this.materials = materials;

      loading.dismiss();
    })
  }

  async loadTaskFeedback() {

    const loading =  await this.loadingController.create({
      message: "Lade Fortschritt...",
    });

    await loading.present();

   this.authService.getFromEndpoint('teams/'+this.task.team_id+'/tasks/'+this.task.id+'/mydeliveries/state').subscribe(feedbacks => {
     this.state = feedbacks;
      loading.dismiss();
    })
  }


  async notifyUser(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 1000,
      position: 'top',
    });
    toast.present();
  }
}
